<router-outlet></router-outlet>
<vex-floating-switch></vex-floating-switch>
